<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     物料表
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="mm-material header-padding">
    
    <f-page-header />

    <div class="filter-container">

      <div class="filter-box">

        <span class="filter-item">
          <f-radio-btn-group v-model="query.type" :groups="radios" type="minor" @change="fetchData(1)" />
        </span>

        <span class="filter-item sm">
          <f-search-input v-model="query.keyword" @change="fetchData(1)" />
        </span>
        
      </div>

      <div class="toolbox">
        <el-button type="success" icon="el-icon-plus" @click="edit()">新建物料</el-button>
        <el-button type="success" icon="el-icon-upload2" plain @click="importShow = true">导入</el-button>
      </div>
    </div>

    <div class="flex">
      <el-card v-loading="loading" class="table-card bd" shadow="never">
        <el-table
          ref="listTable"
          :data="list"
          style="width: 100%"
          size="medium"
          class="padding-small"
          @selection-change="handleSelectionChange">

          <el-table-column
            type="selection"
            width="60">
          </el-table-column>

          <el-table-column label="物料编码" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.material_no }}</span>
            </template>
          </el-table-column>

          <el-table-column label="名称" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.material_title }}</span>
            </template>
          </el-table-column>

          <el-table-column label="规格型号" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.model }}</span>
            </template>
          </el-table-column>

          <el-table-column label="类型" min-width="80" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">原材料</span>
              <span v-if="scope.row.type == 2">半成品</span>
              <span v-if="scope.row.type == 3">成品</span>
            </template>
          </el-table-column>

          <el-table-column label="数量" min-width="80" show-overflow-tooltip align="right">
            <template slot-scope="scope">
              <span class="number font-lg">{{ scope.row.stock_left }}</span>
            </template>
          </el-table-column>

          <el-table-column label="单位" min-width="60" show-overflow-tooltip align="right">
            <template slot-scope="scope">
              <span class="text-muted">{{ scope.row.stock_unit }}</span>
            </template>
          </el-table-column>

          <el-table-column width="20" />

          <el-table-column label="备注" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>

          <el-table-column label="更新时间" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.updatetime | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="right" min-width="160">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row)">编辑</el-button>
              <el-button type="text" @click="deleteOne(scope.row)">删除</el-button>
            </template>
          </el-table-column>

          <template slot="empty">
            <img class="image huger mt-lg" src="@/assets/empty.png">
            <div class="font-md mb-hg">暂无数据</div>
          </template>
        </el-table>
      </el-card>
    </div>

    <f-table-footer checkbox :list="list" :selection="multiSelection" @toggle="toggleAll" :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData">
      <template slot="left">
        <el-button plain :disabled="multiSelection.length === 0" size="mini" @click="deleteMulti">删除</el-button>
        <el-button class="ml-lg" plain :disabled="total === 0" size="mini" @click="exportM">导出</el-button>
      </template>
    </f-table-footer>

    <new-material v-if="dialogShow" :show.sync="dialogShow" :mid="activeMid" @success="fetchData(1)" />

    <mm-material-import v-if="importShow" :show.sync="importShow" @submit="fetchData(1)" />
  </div>
</template>

<script>
import { getMaterialListApi, delMaterialApi, exportMaterialApi } from '@/api/mm/materialApi'

export default {
  name: "MmMaterial",

  components: {
    MmMaterialImport: () => import('@/views/mm/components/MmMaterialImport'),
    NewMaterial: () => import('@/views/mm/components/NewMaterial'),
  },

  data() {
    return {
      activeMid: null,
      dialogShow: false,
      importShow: false,
      query: {
        keyword: '',
        pindex: 1,
        type: 0,
        psize: this.$store.state.commonStore.psize,
      },
      total: 0,
      multiSelection: [],
      radios: [
        { value: 0, title: '全部物料', separate: true },
        { value: 1, title: '原材料' },
        { value: 2, title: '半成品' },
        { value: 3, title: '成品' },
      ],
      list: [],
      loading: false
    }
  },

  computed: {
  },

  created() {
    this.fetchData()
  },


  methods: {
    fetchData (page, loading = true) {
      if (page) this.query.pindex = page
      if (loading) this.loading = true
      getMaterialListApi(this.query).then(res => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
        }
      })
    },

    handleSelectionChange (val) {
      this.multiSelection = val
    },

    toggleAll() {
      this.$refs.listTable.toggleAllSelection();
    },

    edit(row) {
      this.activeMid = row ? row.mid : null
      this.dialogShow = true
    },

    deleteOne(item) {
      this.$confirm(`即将删除物料<span class="text-primary"> ${item.material_no}</span>，是否继续 ？`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        delMaterialApi({ mids: [item.mid] }).then(res => {
          this.loading = false
          if (!res.errno) {
            this.$message.success('物料删除成功！')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => { });
    },

    deleteMulti() {
      let tmp = this.multiSelection.map(v => v.mid)
      this.$confirm(`即将删除<span class="text-primary"> ${tmp.length}</span> 个物料，是否继续？`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        delMaterialApi({ mids: tmp }).then(res => {
          this.loading = false
          if (!res.errno) {
            this.$message.success('物料删除成功！')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => { });
    },

    exportM() {
      exportMaterialApi(this.query).then(res => {
        if (!res.errno) {
          window.open(res.data.url)
          this.$message.success('物料导出成功！')
        }
      })
    },
  }

}
</script>

<style lang="scss" scoped>
.mm-material {
  position: relative;
  .location {
    width: 280px;
    margin-right: 10px;
  }
}
</style>
